import { Table } from "@/components/elements/Table";
import { EMPTY_STR } from "@/constants/string";
import { useTable } from "@/hooks/useTable";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { truncateWithEllipsis } from "@/utils/string";
import { MAX_COMPANY_DESCRIPTION_AND_MEMO_LENGTH } from "@/features/company/constants/length";
import { divider } from "@/theme/colors";
import { TPartnerImportRow } from "@/features/partner/types/partner-import";

type TPartnerAfterImportProps = {
  rows: TPartnerImportRow[];
  isLoading: boolean;
};

export const PartnerAfterImport = ({ rows, isLoading }: TPartnerAfterImportProps) => {
  const columns = useMemo<MRT_ColumnDef<TPartnerImportRow>[]>(
    () => [
      {
        header: "行",
        Cell: ({ row }) => row.index + 1,
        size: 14,
      },
      {
        header: "パートナー管理番号",
        size: 158,
        Cell: ({ row }) => row.original.managementNumber || EMPTY_STR.TEXT,
      },
      {
        header: "パートナー名",
        size: 166,
        Cell: ({ row }) => row.original.partnerName || EMPTY_STR.TEXT,
      },
      {
        header: "国籍",
        size: 116,
        Cell: ({ row }) => row.original.nationality || EMPTY_STR.TEXT,
      },
      {
        header: "電話番号",
        size: 120,
        Cell: ({ row }) => row.original.phoneNumber || EMPTY_STR.TEXT,
      },
      {
        header: "メールアドレス",
        size: 130,
        Cell: ({ row }) => row.original.email || EMPTY_STR.TEXT,
      },
      {
        header: "所在地",
        size: 116,
        Cell: ({ row }) => row.original.location || EMPTY_STR.TEXT,
      },
      {
        header: "担当者",
        size: 74,
        Cell: ({ row }) => row.original.contactPerson || EMPTY_STR.TEXT,
      },
      {
        header: "契約情報",
        size: 146,
        Cell: ({ row }) => truncateWithEllipsis(row.original.contractInfo || EMPTY_STR.TEXT, MAX_COMPANY_DESCRIPTION_AND_MEMO_LENGTH),
      },
      {
        header: "請求情報",
        size: 116,
        Cell: ({ row }) => truncateWithEllipsis(row.original.billingInfo || EMPTY_STR.TEXT, MAX_COMPANY_DESCRIPTION_AND_MEMO_LENGTH),
      },
      {
        header: "メモ",
        size: 158,
        Cell: ({ row }) => truncateWithEllipsis(row.original.memo || EMPTY_STR.TEXT, MAX_COMPANY_DESCRIPTION_AND_MEMO_LENGTH),
      },
    ],
    [],
  );

  const { table } = useTable({ columns, rows });

  return <Table table={table} isLoading={isLoading} borderColor={divider.high} height="calc(100vh - 620px)" />;
};
